export const RECOVERY_ACTIONS = {
    RECORD_ONLY: "record_only",
    MOVE_TODAYS_LESSONS: "move_todays_lessons",
    SHIFT_ENTIRE_SCHEDULE: "shift_entire_schedule",
    CUSTOM: "custom",
};

export const getRecoveryActionLabel = (action) => {
    switch (action) {
        case RECOVERY_ACTIONS.RECORD_ONLY:
            return "Just Record Attendance";

        case RECOVERY_ACTIONS.MOVE_TODAYS_LESSONS:
            return "Move Today's Lessons";

        case RECOVERY_ACTIONS.SHIFT_ENTIRE_SCHEDULE:
            return "Shift Entire Schedule";

        case RECOVERY_ACTIONS.CUSTOM:
            return "Custom Recovery Plan";

        default:
            return "Recovery Plan";
    }
};

export const createRecoveryPlan = ({
    action,
    childId,
    childName,
    absenceDates = [],
    notes = "",
}) => ({
    id: `recovery-${Date.now()}`,
    action,
    childId,
    childName,
    absenceDates,
    notes,
    createdAt: new Date().toISOString(),
    status: "preview",
});
export const getEventDateForRecovery = (event) =>
    event?.date_start ||
    event?.date ||
    event?.due_date ||
    event?.scheduled_date ||
    "";

export const moveEventToRecoveryDate = ({
    event,
    nextDateString,
    reason = "",
    note = "",
    recoveryPlan = "",
}) => ({
    ...event,
    date: event.date ? nextDateString : event.date,
    date_start: event.date_start ? nextDateString : event.date_start,
    date_end: event.date_end ? nextDateString : event.date_end,
    due_date: event.due_date ? nextDateString : event.due_date,
    scheduled_date: event.scheduled_date ? nextDateString : event.scheduled_date,
    recovery_moved: true,
    recovery_moved_at: new Date().toISOString(),
    recovery_reason: reason,
    recovery_note: note,
    recovery_plan: recoveryPlan,
});

export const isClassTimerSession = (event) =>
    Boolean(
        event?.is_calendar_session ||
            event?.is_timed_session ||
            event?.created_from === "class_timer_lesson_flow"
    );

export const isQuestEvent = (event) => !isClassTimerSession(event);